export default {
    intCodigoRetorno: 0,
    isError: false,
    isTokenError: false,
    strErrorMessage: '',
    vchVersaoParametros: null,
    arrJogo: [
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 141,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 2.22,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-08 09:52',
        sdtDataJogo: '2019-02-23',
        sntQuantidadeApostas: 2,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000140',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 140,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 2.22,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-08 09:52',
        sdtDataJogo: '2019-02-13',
        sntQuantidadeApostas: 2,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000140',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 139,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 4.44,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-08 09:48',
        sdtDataJogo: '2019-02-13',
        sntQuantidadeApostas: 1,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000139',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 138,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 7.89,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-07 17:34',
        sdtDataJogo: '2019-02-07',
        sntQuantidadeApostas: 3,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000138',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 137,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 2.22,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-07 17:17',
        sdtDataJogo: '2019-02-07',
        sntQuantidadeApostas: 1,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000137',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 136,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 5.55,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-07 17:13',
        sdtDataJogo: '2019-02-23',
        sntQuantidadeApostas: 1,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000136',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 135,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 4.44,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-07 17:11',
        sdtDataJogo: '2019-02-07',
        sntQuantidadeApostas: 1,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000135',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 134,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 5.55,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-07 17:04',
        sdtDataJogo: '2019-02-27',
        sntQuantidadeApostas: 1,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000134',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 133,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 15.55,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-07 17:02',
        sdtDataJogo: '2019-02-16',
        sntQuantidadeApostas: 2,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000132',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 132,
        numPremio: 0,
        numValor: 0,
        numValorApostas: 15.55,
        numValorTotal: 0,
        sdtDataCobrancaJI: null,
        sdtDataHora: '2019-02-07 17:02',
        sdtDataJogo: '2019-02-13',
        sntQuantidadeApostas: 2,
        vchCodigoSeguranca: null,
        vchDescricao: 'SENINHA',
        vchETicket: '999000000001000132',
        vchNumero: null,
        vchPremio: null,
        vchTipoJogo: null
      }
    ]
  }


// WEBPACK FOOTER //
// ./src/mocking/lista-de-apostas-retorno.js